import { Button } from "src/shared/components/forms"
import Icon from "src/shared/icons"
import { IconNamesProps } from "src/shared/icons/Icon"

const PASOS: { icon: IconNamesProps["name"]; title: string; text: string }[] = [
    {
        icon: "checkFilled",
        title: "Se validarán los movimientos",
        text: "Confirma que los ingresos, pagos, cortesías, anticipos y retiros de efectivo sean correctos.",
    },
    {
        icon: "CoinsFill",
        title: "Se validará el efectivo",
        text: "Confirma que el conteo de efectivo coincida con el registrado en el sistema.",
    },
    {
        icon: "FolderFill",
        title: "El corte quedará cerrado",
        text: "El estado del corte cambiará de pendiente a cerrado. El turno activo no se verá afectado.",
    },
]

type ConfirmacionCorteAnteriorProps = {
    subtitle: string
    disabled: boolean
    onConfirm: () => void
}

// Contenido del modal de confirmación para cerrar un corte pendiente (anterior al turno actual)
const ConfirmacionCorteAnterior = ({ subtitle, disabled, onConfirm }: ConfirmacionCorteAnteriorProps) => (
    <div className="modal-corte-anterior">
        <div className="modal-corte-anterior__header-icon">
            <Icon name="DollarSquare" color="var(--primary)" height={50} width={50} />
        </div>
        <h2 className="modal-corte-anterior__title">¿Confirmas el cierre del corte?</h2>
        <p className="modal-corte-anterior__subtitle">{subtitle}</p>
        <ul className="modal-corte-anterior__pasos">
            {PASOS.map(({ icon, title, text }) => (
                <li key={title} className="modal-corte-anterior__paso">
                    <div className="modal-corte-anterior__paso-icon">
                        <Icon name={icon} color="var(--primary)" height={32} width={32} />
                    </div>
                    <div>
                        <p className="modal-corte-anterior__paso-title">{title}</p>
                        <p className="modal-corte-anterior__paso-text">{text}</p>
                    </div>
                </li>
            ))}
        </ul>
        <div className="modal-corte-anterior__footer">
            <Button
                disabled={disabled}
                text="Confirmar cierre de corte"
                className="modal-corte-anterior__button"
                onClick={onConfirm}
            />
        </div>
    </div>
)

export default ConfirmacionCorteAnterior
